// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Proposal_wrapper__hUZS6","title":"Proposal_title__1iB8t"};